<template>
    <div class="bind_device psr" :style="'height:' + (bodyHeight) + 'px'">
        <img class="logo_box" src="../assets/logo_2.png">
        <div class="device_detail">
            <!-- <div>ccid:{{ device.ccid ? device.ccid : '---' }}</div>
            <div class="btn_box">
                <button v-if="!is_bind" @click="openDeviceList">绑定设备</button>
                <button v-else @click="unbind">解绑设备</button>
                <button :disabled="!is_bind" @click="openDataSet">预警阈值</button>
            </div> -->
            <div class="clearfix item_box">
                <div class="fl left">床位患者信息：</div>
                <div class="fl right" :class="{ right_no: !patient_id }">
                    <span v-if="patient_id">住院号（{{ patient_id }}）</span>
                    <span class="red_font" v-else>暂无住院号信息</span>
                </div>
                <!-- <div class="fl refresh_btn btn_green">刷新</div> -->
            </div>
            <div class="clearfix item_box">
                <div class="fl left">绑定久乐表：</div>
                <div class="fl right" :class="{ right_no: !device.ccid }">
                    <span v-if="device.ccid">已绑定久乐表（CCID：{{ device.ccid }}）</span>
                    <span v-else class="red_font clearfix">未绑定手表，点击绑定
                        <img class="right_icon fr" @click="openDeviceList" src="../../static/right_icon.png">
                    </span>
                </div>
                <div class="fl refresh_btn btn_red" v-if="device.ccid" @click="unbind">解绑设备</div>
            </div>
            <div class="clearfix item_box">
                <div class="fl left">设置报警阈值：</div>
                <div class="fl right right_no" v-if="!device.high_heartrate_value">
                    <span class="red_font clearfix">未设置报警阈值，点击设置
                        <img class="right_icon fr" @click="openDataSet" src="../../static/right_icon.png">
                    </span>
                </div>
                <div v-else class="fl refresh_btn btn_green" @click="openDataSet">更换阈值</div>
            </div>

            <div class="warnForm clearfix" v-if="device.high_heartrate_value">
                <div class="fl left"></div>
                <div class="fl warn_box">
                    <div class="formTitle">心率预警阈值</div>
                    <div class="clearfix formLine">
                        <div class="fl line_left">最低值<span class="unit">(bpm)</span>：</div>
                        <div class="fl line_right">{{ device.low_heartrate_value }}</div>
                        <div class="fl line_left">持续</div>
                        <div class="fl line_right width_1">{{ device.low_heartrate_time }}分钟</div>
                        <div class="fl line_left">低心率预警</div>

                    </div>
                    <div class="clearfix formLine">
                        <div class="fl line_left">最高值<span class="unit">(bpm)</span>：</div>
                        <div class="fl line_right">{{ device.high_heartrate_value }}</div>
                        <div class="fl line_left">持续</div>
                        <div class="fl line_right width_1">{{ device.high_heartrate_time }}分钟</div>
                        <div class="fl line_left">高心率预警</div>

                    </div>
                    <div class="formTitle">血氧预警阈值</div>
                    <div class="clearfix formLine">
                        <div class="fl line_left">最低值<span class="unit">(%)</span>：</div>
                        <div class="fl line_right">{{ device.spo2 }}</div>
                        <div class="fl line_left">持续</div>
                        <div class="fl line_right width_1">{{ device.low_spo_time }}分钟</div>
                        <div class="fl line_left">低血氧预警</div>
                    </div>
                </div>
                <div class="fl warn_box box_width">
                    <div class="formTitle">频率设置</div>
                    <div class="clearfix formLine">
                        <div class="fl line_left">采集频率：</div>
                        <div class="fl line_right">{{ device.ppg / 60 }}分钟</div>
                    </div>
                    <div class="clearfix formLine">
                        <div class="fl line_left">上传频率：</div>
                        <div class="fl line_right">{{ device.normal_rate_minute }}</div>
                    </div>
                    <div class="clearfix formLine">
                        <div class="fl line_left">离院预警：已开启</div>
                    </div>
                    <div class="clearfix formLine">
                        <div class="fl line_left">长按SOS预警：已开启</div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog :visible.sync="showDevice" class="bind_list" width="60%" title="绑定手表">
            <el-table :data="device_list" v-loading="table_loading" border height="400" header-row-class-name="table_head">
                <el-table-column prop="ccid" label="CCID" align="center">
                </el-table-column>
                <el-table-column prop="bed_number" label="床位绑定关系" align="center">
                    <template slot-scope="scope">
                       <div v-if="scope.row.bind == 2" class="unbind_text" >未绑定</div>
                        <div v-else class="bind_text">已绑定({{ scope.row.bed_number }}床)</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" min-width="30%">
                    <template slot-scope="scope">
                        <button v-if="scope.row.bind == 2" class="success_btn" @click="bindDevice(scope.row)">绑定</button>
                        <button v-else class="disable_btn">已绑定</button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog width="60%" top="10vh" title="更换阈值" class="edit_dialog" :visible.sync="warnVisibleFlag"
            @close="closeDialog('warnForm')">
            <div style="width: 100%;padding-left: 1rem ;">
                <el-form :model="warnForm" ref="warnForm" :rules="warnRules" label-width="2.2rem">
                    <div class="_title">
                        心率预警阈值
                    </div>
                    <el-row>
                        <el-col :span="10">
                            <el-form-item label="最低值(bpm)：" prop="low_heartrate_value">
                                <el-select v-model="warnForm.low_heartrate_value" placeholder="60">
                                    <el-option v-for="(item, index) in low_heartrate_list" :key="index" :label="item"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label="持续：" prop="low_heartrate_time" label-width="1.2rem">
                                        <el-select v-model="warnForm.low_heartrate_time" placeholder="60">
                                            <el-option label="10分钟" :value="10">
                                            </el-option>
                                            <el-option label="20分钟" :value="20">
                                            </el-option>
                                            <el-option label="30分钟" :value="30">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <div class="warn_text_style">低心率预警</div>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="10">
                            <el-form-item label="最高值(bpm)：" prop="high_heartrate_value">
                                <el-select v-model="warnForm.high_heartrate_value" placeholder="140">
                                    <el-option v-for="(item, index) in high_heartrate_list" :key="index" :label="item"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label="持续：" prop="high_heartrate_time" label-width="1.2rem">
                                        <el-select v-model="warnForm.high_heartrate_time" placeholder="60">
                                            <el-option label="10分钟" :value="10">
                                            </el-option>
                                            <el-option label="20分钟" :value="20">
                                            </el-option>
                                            <el-option label="30分钟" :value="30">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <div class="warn_text_style">高心率预警</div>
                                </el-col>
                            </el-row>

                        </el-col>
                    </el-row>
                    <div class="_title">
                        血氧预警阈值
                    </div>
                    <el-row>
                        <el-col :span="10">
                            <el-form-item label="最低值(%)：" prop="spo2">
                                <el-select v-model="warnForm.spo2" placeholder="92">
                                    <el-option v-for="(item, index) in spo2_list" :key="index" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label="持续：" prop="low_spo_time" label-width="1.2rem">
                                        <el-select v-model="warnForm.low_spo_time" placeholder="60">
                                            <el-option label="10分钟" :value="10">
                                            </el-option>
                                            <el-option label="20分钟" :value="20">
                                            </el-option>
                                            <el-option label="30分钟" :value="30">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <div class="warn_text_style">低血氧预警</div>
                                </el-col>
                            </el-row>


                        </el-col>
                    </el-row>

                    <div class="_title">
                        频率设置
                    </div>
                    <el-row>
                        <el-col :span="9.5">
                            <el-form-item label="采集频率：" prop="ppg">
                                <div class="font-16">
  {{  uploadfrequency  }}
                                </div>
                                  
                                    
                                <!-- <el-select v-model="warnForm.ppg" placeholder="92">
                                    <el-option v-for="(item, index) in ppg_list" :key="index" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select> -->
                            </el-form-item>

                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="上传频率：" prop="normal_rate">
                                <el-select v-model="warnForm.normal_rate" placeholder="92" v-if="warnForm.ppg == 300">
                                    <el-option v-for="(item, index) in normal_rate_list_1" :key="index" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                                <el-select :disabled="!warnForm.ppg" v-model="warnForm.normal_rate" placeholder="92" v-else>
                                    <el-option v-for="(item, index) in normal_rate_list_2" :key="index" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>


                </el-form>
            </div>
            <div style="text-align: center;font-size: 0.3rem;font-weight: 400;color: #585858;margin-top: .4rem;">设置成功后，{{
                conputedMinute }}后生效
            </div>

            <div slot="footer" class="dialog-footer" align="center">
                <button class="cancel_btn" @click="warnVisibleFlag = false">取 消</button>
                <button class="confirm_btn" @click="comfirmWarnEdit">确 定</button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import { Loading } from 'element-ui';
export default {
    data() {
        return {
            bed: '',
            room: "",
            zone: "",
            patient_id: "",
            device: {},
            showDevice: false,
            table_loading: false,
            device_list: [],
            warnVisibleFlag: false,
            warnForm: {
                low_heartrate_value: "",
                high_heartrate_value: "",
                spo2: "",
                low_heartrate_time: "",
                high_heartrate_time: "",
                low_spo_time: ""
            },
            low_heartrate_list: [],
            high_heartrate_list: [],
            spo2_list: [],
            warnRules: {
                low_heartrate_value: [
                    { required: true, message: "请选择", trigger: "blur" },
                ],
                low_heartrate_time: [
                    { required: true, message: "请选择", trigger: "blur" },
                ],
                high_heartrate_value: [
                    { required: true, message: "请选择", trigger: "blur" },
                ],
                high_heartrate_time: [
                    { required: true, message: "请选择", trigger: "blur" },
                ],
                spo2: [{ required: true, message: "请选择", trigger: "blur" }],
                low_spo_time: [{ required: true, message: "请选择", trigger: "blur" }],
                ppg: [{ required: true, message: "请选择", trigger: "blur" }],
                normal_rate: [{ required: true, message: "请选择", trigger: "blur" }],
            },
            loadingOptions: {
                target: ".bind_device",
                lock: true,
                text: '加载中···',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            },
            loading: undefined,
            bodyHeight: 0,
            value1: true,
            ppg_list: [
                {
                    label: "5分钟",
                    value: 300
                },
                {
                    label: "10分钟",
                    value: 600
                }
            ],
            normal_rate_list_1: [
                {
                    label: "10分钟",
                    value: 2
                },
                {
                    label: "15分钟",
                    value: 3
                },
                {
                    label: "20分钟",
                    value: 4
                },
                {
                    label: "25分钟",
                    value: 5
                },
                {
                    label: "30分钟",
                    value: 6
                },
            ],
            normal_rate_list_2: [
                {
                    label: "20分钟",
                    value: 2
                },
                {
                    label: "30分钟",
                    value: 3
                },
                {
                    label: "40分钟",
                    value: 4
                },
                {
                    label: "50分钟",
                    value: 5
                },
                {
                    label: "60分钟",
                    value: 6
                },
            ]
        };
    },
    computed: {
        uploadfrequency(){
            let index = this.ppg_list.findIndex(item => item.value == this.warnForm.ppg);
            if(index>=0){
                    return this.ppg_list[index].label
            }else{
                return "10分钟"
            }
        },
        conputedMinute() {
            let m = ''
            if (this.warnForm.ppg == 300) {
                this.normal_rate_list_1.forEach(item => {
                    if (this.warnForm.normal_rate == item.value) {
                        m = item.label
                    }
                })
            } else if (this.warnForm.ppg == 600) {
                this.normal_rate_list_2.forEach(item => {
                    if (this.warnForm.normal_rate == item.value) {
                        m = item.label
                    }
                })
            }
            return m
        }
    },
    watch: {
        value1() {
            if (!this.value1) {
                console.log(this.value1);
                this.$alert('<div><div>此报警设置为出厂默认设置，如需修改可联系久乐科技技术人员配合调整</div><b>联系电话：400-9616-639</b></div>', '温馨提示', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '好的',
                });
                setTimeout(() => {
                    this.value1 = true
                }, 200)
            }
        }
    },
    mounted() {
        let that = this
        that.bodyHeight = window.innerHeight;
        window.onresize = () => {
            return (() => {
                that.bodyHeight = window.innerHeight;
            })();
        };
        for (let index = 35; index <= 60; index++) {
            this.low_heartrate_list.push(index);
        }
        for (let index = 100; index <= 180; index++) {
            this.high_heartrate_list.push(index);
        }
        for (let index = 85; index <= 95; index++) {
            this.spo2_list.push(index);
        }
        const query = this.$route.query

        this.patient_id = query.inpatientCode
        this.bed = query.bedNumber
        this.room = query.roomNumber
        this.zone = query.zoneNumber
        this.getDeviceList({
            bed_number: this.bed,
            room_number: this.room?this.room:9999,
            zone_number: this.zone
        })

        this.loading = Loading.service(this.loadingOptions);
    },

    methods: {
        closeDialog(formName) {
            this.$refs[formName].resetFields();
        },
        comfirmWarnEdit() {
            this.$refs["warnForm"].validate((valid) => {
                if (valid) {
                    let data = {
                        ccid: this.device.ccid,
                        low_heartrate_value: this.warnForm.low_heartrate_value,
                        low_heartrate_time: this.warnForm.low_heartrate_time,
                        high_heartrate_value: this.warnForm.high_heartrate_value,
                        high_heartrate_time: this.warnForm.high_heartrate_time,
                        low_spo_time: this.warnForm.low_spo_time,
                        spo2: this.warnForm.spo2,
                        ppg: this.warnForm.ppg,
                        normal_rate: this.warnForm.normal_rate,
                    };
                    console.log(data);
                    axios({
                        url: process.env.BASE_API + 'api/hope/edit',
                        method: "post",
                        data,
                    }).then(res => {
                        if (res.data.status == 200) {
                            this.$message({
                                message: "操作成功",
                                type: "success",
                            });
                            setTimeout(() => {
                                this.warnVisibleFlag = false;
                                this.getDeviceList({
                                    bed_number: this.bed,
                                    room_number: this.room?this.room:9999,
                                    zone_number: this.zone
                                })
                            }, 1500);
                        }
                        else {
                            this.$message.error(res.data.message)
                        }
                    }).catch(err => {
                        this.$message.error(err.message)

                    })

                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        openDeviceList() {
            this.showDevice = true
            this.getDeviceList({ zone_number: this.zone })
        },
        openDataSet() {
            if (this.device.ccid) {
                this.warnForm = {
                    low_heartrate_value: this.device.low_heartrate_value,
                    low_heartrate_time: this.device.low_heartrate_time,
                    high_heartrate_value: this.device.high_heartrate_value,
                    high_heartrate_time: this.device.high_heartrate_time,
                    spo2: this.device.spo2,
                    low_spo_time: this.device.low_spo_time,
                    ppg: this.device.ppg,
                    normal_rate: this.device.normal_rate,
                }
                this.warnVisibleFlag = true;
            } else {
                this.$message.error('请先绑定久乐表')
            }

        },
        bindDevice(item) {
            let data = {
                ccid: item.ccid,
                zone_number: this.zone,
                room_number: this.room?this.room:9999,
                patient_id: this.patient_id ? this.patient_id : "",
                bed_number: this.bed,
                bind: 1,
            }
            // if (!data.room_number) {
            //     delete data.room_number
            // }
            axios({
                url: process.env.BASE_API + 'api/hope/assign_beds',
                method: "post",
                data,
            }).then(res => {
                if (res.data.status == 200) {
                    this.$message({
                        type: "success",
                        message: '绑定成功'
                    })
                    setTimeout(() => {
                        this.showDevice = false
                        this.getDeviceList({
                            bed_number: this.bed,
                            room_number: this.room?this.room:9999,
                            zone_number: this.zone
                        })
                    }, 2000);
                }
                else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => {
                this.$message.error(err.message)

            })
        },
        unbind() {
            this.$confirm('此操作将解绑该设备, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    ccid: this.device.ccid,
                    zone_number: this.zone,
                    room_number: this.room?this.room:9999,
                    bed_number: this.bed,
                    patient_id: this.patient_id ? this.patient_id : "",
                    bind: 2,
                }
                axios({
                    url: process.env.BASE_API + 'api/hope/assign_beds',
                    method: "post",
                    data,
                }).then(res => {
                    if (res.data.status == 200) {
                        this.$message({
                            type: "success",
                            message: '解绑成功'
                        })
                        setTimeout(() => {
                            this.showDevice = false
                            this.getDeviceList({
                                bed_number: this.bed,
                                room_number: this.room?this.room:9999,
                                zone_number: this.zone
                            })
                        }, 2000);
                    }
                    else {
                        this.$message.error(res.data.message)
                    }
                }).catch(err => {
                    this.$message.error(err.message)

                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });
            });
        },
        getDeviceList(data) {

            let requestData = Object.assign({}, data)
            // if (!requestData.room_number) {
            //     delete requestData.room_number
            // }
            this.table_loading = true
            axios({
                url: process.env.BASE_API + 'api/hope/list',
                method: 'post',
                data: requestData,
            }).then(res => {
                this.table_loading = false
                this.loading.close();
                if (res.data.status == 200) {
                    if (res.data.result.length) {
                        if (!data.bed_number) {
                            this.device_list = res.data.result
                        } else {
                            if (res.data.result[0].bind == 1) {
                                this.device = res.data.result[0]
                                this.device.ppg = Number(this.device.ppg)
                                this.device.normal_rate = Number(this.device.normal_rate)
                                if (this.device.ppg == 300) {
                                    this.normal_rate_list_1.forEach(item => {
                                        if (this.device.normal_rate == item.value) {
                                            this.device.normal_rate_minute = item.label
                                        }
                                    })
                                } else if (this.device.ppg == 600) {
                                    this.normal_rate_list_2.forEach(item => {
                                        if (this.device.normal_rate == item.value) {
                                            this.device.normal_rate_minute = item.label
                                        }
                                    })
                                }
                            } else {
                                this.device = {}
                            }
                        }
                    } else {
                        this.device = {}
                    }
                    console.log(this.device_list);

                }
                else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => {
                this.table_loading = true
                this.$message.error(err.message)
            })
        },
    }
}

</script>
<style  scoped>
@import '../assets/bind_device.css';
</style>


// WEBPACK FOOTER //
// src/view/bind_device.vue